import { getCategoriesThunk } from '@redux/features/category.slice';
import { AnimatedListSkeleton, AnimatedTable, AnimatedTableBody, AnimatedTableRow } from 'components/animations';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import BreadCrumb from 'Common/BreadCrumb';
import React, { FC, useEffect, useState } from 'react';
import ButtonBase from 'components/ui/buttons/ButtonBase';
import AddCategoryModal from './AddCategoryModal';

const ProductCategory: FC = () => {
    const [page, setPage] = useState<number>(0);
    const [showAddModal, setShowAddModal] = useState<boolean>(false);

    const dispatch = useAppDispatch();
    const { categories, loading } = useAppSelector(
        (state: RootState) => (state as any).categoryState || { categories: [], loading: false }
    );

    const changePage = (p: number) => setPage(p);

    useEffect(() => {
        dispatch(getCategoriesThunk());
    }, [page, dispatch]);

    return (
        <>
            <AddCategoryModal show={showAddModal} handleClose={() => setShowAddModal(false)} />
            <BreadCrumb pageTitle={`Categories List`} />
            <section className="py-5">
                <div className=" p-3 flex flex-col gap-2 bg-[#fff]">
                    <div className="flex w-full items-center justify-between">
                        <h3 className="font-extrabold text-[#bd902e]">Categories List</h3>
                        {/* <ButtonBase innerText="Add Category" onClick={() => setShowAddModal(true)} /> */}
                    </div>
                    {loading ? (
                        <AnimatedListSkeleton rows={8} />
                    ) : (
                        <>
                            <div>
                                <div className="overflow-x-auto">
                                    <AnimatedTable className="table-custom w-full border-separate border-spacing-y-1 whitespace-nowrap">
                                        <thead className="ltr:text-left rtl:text-right">
                                            <tr
                                                className="relative rounded-md bg-slate-50 after:absolute after:bottom-0
                    after:left-0 after:top-0 after:border-l-2
                    after:border-transparent [&.active]:after:border-custom-500"
                                            >
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">ID</th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">Category Name</th>
                                            </tr>
                                        </thead>
                                        <AnimatedTableBody loading={loading} itemCount={categories?.length ?? 0} animationKey={`categories-${page}`}>
                                            {(categories || []).map((c: any) => (
                                                <AnimatedTableRow
                                                    rowKey={c?.id}
                                                    detailRecord={c}
                                                    className="relative rounded-md bg-slate-50 after:absolute after:bottom-0
                        after:left-0 after:top-0 after:border-l-2 hover:bg-[#bd902e10]
                        after:border-transparent [&.active]:after:border-custom-500"
                                                >
                                                    <td className="px-3.5 py-2.5">{c?.id || `-`}</td>
                                                    <td className="px-3.5 py-2.5">{c?.categoryName || `-`}</td>
                                                </AnimatedTableRow>
                                            ))}
                                        </AnimatedTableBody>
                                    </AnimatedTable>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </section>
        </>
    );
};

export default ProductCategory;
